import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../../shared/components/HeaderSearchRefreshFilterOptions';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import Row from '../../../shared/components/Row';
import Card from '../../../shared/components/Card';
import CardBody from '../../../shared/components/CardBody';
import Paginator from '../../../shared/components/Paginator';
import { OutsourceListMode } from './OutsourceListMode';
import { OutsourceList } from './OutsourceList';
import { OutsourceState } from '../../../shared/model/OutsourceState';
import { OutsourceSearchRequest } from './outsource-search/OutsourceSearchRequest';
import { OutsourceSearchTask } from './outsource-search/OutsourceSearchTask';
import GenericRequest, { METHOD_POST } from '../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../shared/webservices/endpoint';
import cookie from 'react-cookies';
import { AUTH_TOKEN } from '../../../shared/utils/CookiesManager';
import Alert from 'react-s-alert';
import { CompaniesExportRequest } from './companies-export/CompaniesExportRequest';

const OptionsMore = {
    NONE: '',
    DOWNLOAD: 'DOWNLOAD',
};

export class OutsourceListCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            mode: props.initialCardState.mode,
            page: 1,
            data: [],
            error: '',
            filter: props.initialCardState.filter,
            search: props.initialCardState.search,
            loading: false,
            filters: this.initialFilterOptions(),
            collapsed: props.initialCardState.collapsed,
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
            moreOptionSelected: OptionsMore.NONE,
        };
    }

    componentDidMount() {
        if (!this.state.collapsed) {
            this.listOutsources();
        }
    }

    componentDidUpdate(_, prevState) {
        const { saveCardState } = this.props;
        const { mode, search, filter, collapsed } = this.state;

        if ((prevState.collapsed !== collapsed) && !collapsed) {
            this.listOutsources();
        }

        if ( prevState.filter !== filter ) {
            saveCardState({ filter });
        }

        if ( prevState.search !== search ) {
            saveCardState({ search });
        }

        if ( prevState.collapsed !== collapsed ) {
            saveCardState({ collapsed });
        }

        if ( prevState.mode !== mode ) {
            saveCardState({ mode });
        }
    }

    moreOptions() {
        const {
            moreOptionSelected,
        } = this.state;

        return [
            {
                id: 'download_csv',
                title: I18nUtils.tr('TR_EXPORTAR_CSV'),
                active: moreOptionSelected === OptionsMore.DOWNLOAD,
                onClick: this.handleFetchDownloadCsv,
            },
        ];
    }

    handleFetchDownloadCsv = () => {
        const {
            filter,
            page,
            search,
        } = this.state;

        const requestBody = new CompaniesExportRequest();
        requestBody.setPage(page);
        requestBody.setTerm(search);
        requestBody.setState(filter);

        const genericRequest = new GenericRequest(METHOD_POST, ApiEndpoints.OUTSOURCES_EXPORT);
        let headers = genericRequest.headers;
        const authToken = cookie.load(AUTH_TOKEN);
        if (authToken) {
            headers.Authorization = 'Bearer ' + cookie.load(AUTH_TOKEN);
        }
        const requestInit = {
            method: genericRequest.method,
            headers: headers,
            mode: 'cors',
            body: JSON.stringify(requestBody.body()),
        };
        this.setState({ loading: true });
        fetch(genericRequest.url, requestInit)
            .then(response => {
                this.setState({ loading: false });
                response.blob().then(function (myBlob) {
                    const url = URL.createObjectURL(myBlob);
                    window.open(url, '_blank');
                });
            })
            .catch(error => {
                this.setState({loading: false});
                Alert.error(error || I18nUtils.tr('TR_ERROR_AL_EXPORTAR_EL_CSV'));
            });
    };

    render() {
        const {
            mode,
            data,
            error,
            search,
            loading,
            collapsed,
            pagination,
        } = this.state;

        return (
            <Row>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_SUBCONTRATAS').toUpperCase()}
                        subtitle={this.subtitle()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                enableFilter={true}
                                collapsed={collapsed}
                                searchText={search}
                                filterOptions={this.filterOptions()}
                                onRefresh={this.listOutsources}
                                onSearch={this.search}
                                moreOptions={this.moreOptions()}
                                onCollapsed={this.collapse}
                            />
                        )}
                    />
                    {
                        !collapsed ? (
                            <CardBody styles={{ overflowX: 'auto' }}>
                                <OutsourceList
                                    data={data}
                                    mode={mode}
                                    error={error}
                                    selectMode={this.selectMode}
                                />
                                <Paginator
                                    data={pagination}
                                    onPage={this.selectPage}
                                />
                            </CardBody>
                        ) : null
                    }
                </Card>
            </Row>
        );
    }

    initialFilterOptions = () => {
        return [
            {
                id: OutsourceState.ALL,
                title: I18nUtils.tr('TR_TODAS'),
                onClick: () => this.setState({ filter: OutsourceState.ALL, page: 1 }, this.listOutsources),
            },
            {
                id: OutsourceState.ACTIVE,
                title: I18nUtils.tr('TR_ACTIVAS'),
                onClick: () => this.setState({ filter: OutsourceState.ACTIVE, page: 1 }, this.listOutsources),
            },
            {
                id: OutsourceState.INACTIVE,
                title: I18nUtils.tr('TR_INACTIVAS'),
                onClick: () => this.setState({ filter: OutsourceState.INACTIVE, page: 1 }, this.listOutsources),
            },
        ];
    };

    filterOptions = () => {
        return this.state.filters.map((filter) => ( {
            ...filter,
            active: filter.id === this.state.filter,
        } ));
    };

    subtitle = () => {
        const currentFilter = this.state.filters.find((f) => f.id === this.state.filter);
        return currentFilter ? currentFilter.title : '';
    };

    search = (search) => {
        this.setState({ search: search, page: 1 }, this.listOutsources);
    };

    selectPage = (page) => {
        this.setState({ page }, this.listOutsources);
    };

    collapse = () => {
        this.setState((prevState) => ( { collapsed: !prevState.collapsed } ));
    };

    selectMode = (mode) => {
        this.setState({ mode });
    };

    listOutsources = () => {
        const { page, search, filter } = this.state;
        const request = new OutsourceSearchRequest();

        request.setPage(page);
        request.setTerm(search);
        request.setState(filter);

        new OutsourceSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                this.setState({
                    data: res.data, // TODO(adrian): PsOutsource.fromAPIOutsources(res.data)
                    pagination: res.pagination,
                });
            })
            .onFail(error => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };
}

OutsourceListCard.propTypes = {
    saveCardState: PropTypes.func,
    initialCardState: PropTypes.object,
};

OutsourceListCard.defaultProps = {
    saveCardState: () => null,
    initialCardState: {
        mode: OutsourceListMode.GRID,
        search: '',
        filter: OutsourceState.ALL,
        collapsed: false,
    },
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/outsource/list/OutsourceListCard.jsx